import { apiSlice } from "../../apiSlice";

export const admpuestApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getCargosAdmpuest: builder.query({
      query: () => ({
        url: `/Usuarios/Admpuest/getCargos`,
        method: "GET",
      }),
    }),
    createAdmpuest: builder.mutation({
      query: (parameters) => ({
        url: `/Usuarios/Admpuest`,
        method: "POST",
        body: parameters,
      }),
    }),
    updateAdmpuest: builder.mutation({
      query: (parameters) => ({
        url: `/Usuarios/Admpuest/${parameters.CARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
    }),
    //Plantilla de escritorio por cargo (CIMS0120): catalogo marcado y guardado completo
    getAdmescri: builder.query({
      query: (parameters) => ({
        url: `/Usuarios/Admescri/${parameters.CARIDXXX}`,
        method: "GET",
      }),
    }),
    saveAdmescri: builder.mutation({
      query: (parameters) => ({
        url: `/Usuarios/Admescri/${parameters.CARIDXXX}`,
        method: "PUT",
        body: { widgets: parameters.widgets },
      }),
    }),
    deleteAdmpuest: builder.mutation({
      query: (parameters) => ({
        url: `/Usuarios/Admpuest/${parameters.CARIDXXX}/${parameters.PESTORDX}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetCargosAdmpuestQuery,
  useCreateAdmpuestMutation,
  useUpdateAdmpuestMutation,
  useDeleteAdmpuestMutation,
  useLazyGetAdmescriQuery,
  useSaveAdmescriMutation,
} = admpuestApiSlice;
